import React, { useState } from 'react';
import { Meter } from '../ui/Meter';
import { Badge } from '../ui/Badge';
import { RecommendationPanel } from '../intelligence/RecommendationPanel';
import { CourseWorkspace } from './CourseWorkspace';
import { useAccount } from '../../contexts/AccountContext';
import { recommendResources } from '../../utils/recommend';
import { courses } from '../../data/academics';
import { learningFor } from '../../data/learning';
import { percent } from '../../utils/format';
export function LearningPanel() {
  const registered = courses.filter(course => course.status === 'registered');
  const [selectedCode, setSelectedCode] = useState(registered[0]?.code ?? '');
  const {
    signals
  } = useAccount();
  const resourceSuggestions = recommendResources(signals);
  const selected = registered.find(course => course.code === selectedCode) ?? registered[0];
  return <div className="grid gap-6 lg:grid-cols-[280px_minmax(0,1fr)]" data-id="element-2904" data-mp="1cpqjcxjzgo86">
      <div className="space-y-6" data-id="element-2905" data-mp="1hkxkbxlvbete">
        <div className="rounded-card border border-line bg-surface" data-id="element-2906" data-mp="26jbnnwefu3k2">
          <p className="border-b border-line px-5 py-3 text-[12px] font-semibold uppercase tracking-wide text-ink-subtle" data-id="element-2907" data-mp="26iip3ipmukd0">
            Your courses
          </p>
          <ul className="divide-y divide-line" data-id="element-2908" data-mp="1xhu9wkoi6dyj">
            {registered.map(course => {
            const learning = learningFor(course.code);
            const done = learning?.topics.filter(topic => topic.complete).length ?? 0;
            const total = learning?.topics.length ?? 0;
            const progress = total > 0 ? percent(done, total) : 0;
            const active = course.code === selected?.code;
            return <li key={course.id} data-id="element-2909" data-mp="1dsjwxeg56744">
                  <button type="button" onClick={() => setSelectedCode(course.code)} aria-current={active} className={`w-full px-4 py-3 text-left transition-colors duration-150 ease-out ${active ? 'bg-brand-50' : 'hover:bg-canvas'}`} data-id="element-2910" data-mp="19tksrw28iedq">
                    <span className="flex items-center gap-2" data-id="element-2911" data-mp="v6cf8olgdwyl">
                      <span className="cz-num text-[13px] font-semibold text-ink" data-id="element-2912" data-mp="v7x540wtorq4">
                        {course.code}
                      </span>
                      {total === 0 && <Badge tone="neutral" data-id="element-2913" data-mp="l7d4n0h4nr8y">No content</Badge>}
                    </span>
                    <span className="mt-0.5 block truncate text-[12px] text-ink-muted" data-id="element-2914" data-mp="18x7gbeppn9rm">
                      {course.title}
                    </span>
                    {total > 0 && <span className="mt-2 block" data-id="element-2915" data-mp="z87apcgpdg4g">
                        <Meter value={progress} trailing={`${progress}%`} height="thin" data-id="element-2916" data-mp="z7ntxz2sgxs0" />
                      </span>}
                  </button>
                </li>;
          })}
          </ul>
        </div>

        <RecommendationPanel title="Resources for your courses" description="From the Knowledge marketplace." items={resourceSuggestions.map(suggestion => ({
        id: suggestion.item.id,
        title: suggestion.item.title,
        meta: `${suggestion.item.kind} · ${suggestion.item.author}`,
        reason: suggestion.reason,
        to: '/marketplace',
        fallback: suggestion.fallback
      }))} data-id="element-2917" data-mp="1wn1qtpmk4m8p" />
      </div>

      {selected && <CourseWorkspace course={selected} data-id="element-2918" data-mp="2yemkcv7hslzh" />}
    </div>;
}